export const ShippingMethod = {
    bg: {
        to_door: 'До адрес',
        to_office: 'До офис на куриер'
    }
}